import useMount from "hooks/useMount";
import { parsedDateToDate } from "lib/dateUtils";

interface Props {
  defaultDate?: string;
  date: string;
  format?: "short" | "long";
}
export default function LocalizedDate({
  defaultDate,
  date,
  format = "short",
}: Props) {
  const mount = useMount();

  const localDate = parsedDateToDate(date); // This ensures local parsing with T00:00:00

  const formatOptions =
    format === "long"
      ? { dateStyle: "long" as const }
      : {
          year: "numeric" as const,
          month: "numeric" as const,
          day: "numeric" as const,
        };

  if (!mount) {
    return (
      <time dateTime={date}>
        {localDate?.toLocaleDateString("en-US", formatOptions) ||
          defaultDate ||
          date}
      </time>
    );
  }

  return (
    <time dateTime={date}>
      {localDate?.toLocaleDateString(undefined, formatOptions)}
    </time>
  );
}
